import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.036 3.566l-.876-.479a.1.1 0 0 1 0-.175l.876-.479a1 1 0 0 0 .397-.397l.479-.876a.1.1 0 0 1 .175 0l.48.876a1 1 0 0 0 .397.398l.876.479a.1.1 0 0 1 0 .175l-.876.479a1 1 0 0 0-.397.397l-.479.876a.1.1 0 0 1-.175 0l-.48-.876a1 1 0 0 0-.397-.398zm2.908 6.45l-.784-.429a.1.1 0 0 1 0-.175l.784-.428a.1.1 0 0 0 .04-.04l.428-.784a.1.1 0 0 1 .175 0l.43.784a.1.1 0 0 0 .039.04l.784.429a.1.1 0 0 1 0 .175l-.784.428a.1.1 0 0 0-.04.04l-.428.784a.1.1 0 0 1-.175 0l-.43-.784a.1.1 0 0 0-.039-.04zm4-3l-.784-.429a.1.1 0 0 1 0-.175l.784-.428a.1.1 0 0 0 .04-.04l.428-.784a.1.1 0 0 1 .175 0l.43.784a.1.1 0 0 0 .039.04l.784.429a.1.1 0 0 1 0 .175l-.784.428a.1.1 0 0 0-.04.04l-.428.784a.1.1 0 0 1-.175 0l-.43-.784a.1.1 0 0 0-.039-.04zM7.892 6.554a8.554 8.554 0 0 0 12.094 7.79.198.198 0 0 1 .264.259l-.006.012A9 9 0 1 1 8.365 2.764a.21.21 0 0 1 .278.28 8.524 8.524 0 0 0-.751 3.51z"
});

var SvgMoonFilled = function SvgMoonFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgMoonFilled;